var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 3.63181 0.298477 3.33333 0.666667 3.33333H5.72386L3.52859 1.13807C3.26824 0.877722 3.26824 0.455612 3.52859 0.195262C3.78894 -0.0650874 4.21105 -0.0650874 4.4714 0.195262L7.80474 3.52859C8.06509 3.78894 8.06509 4.21105 7.80474 4.4714L4.4714 7.80474C4.21105 8.06509 3.78894 8.06509 3.52859 7.80474C3.26824 7.54439 3.26824 7.12228 3.52859 6.86193L5.72386 4.66667H0.666667C0.298477 4.66667 0 4.36819 0 4Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralArrowIcon);
export default __webpack_public_path__ + "static/media/NeutralArrowIcon.f64e580e7f9f7438c11711dccdf6fa2f.svg";
export { ForwardRef as ReactComponent };